module.exports = __webpack_public_path__ + "img/76_spacewoman.cd779954.jpg";